import React from "react";
import axios from 'axios';
import { connect } from "react-redux";
import Header from "../headerComponent/Header";
import LeftMenu from "../leftSideComponent/LeftSide";
import history from "../../auth/history";
import HeadSearch from "../headSearch/HeadSearch";
import ConsumerList from "./ConsumerList";
import Pagination from "react-js-pagination";
import { store } from '../../redux/store';
import tokenErrorHandler from "../tokenErrorHandler";
import { totalActiveConsumers, totalConsumerNo, totalInActiveConsumers } from "../../redux/misc-data/misc-data.action";
import moment from "moment";
import { CSVLink } from "react-csv";
import { Link } from "react-router-dom";
const httpClient = axios.create();
class AllConsumer extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			phoneNo: this.props.phone,
			statusList: [
				{ value: "Select", label: "Select" },
				// { value: "No Due", label: "No Due/Bill Paid" },
				{ value: "Payment Due", label: "Over Duedate" },
				{ label: "Consumer created", value: "INITIATED" },
				{ label: "No billfetch needed", value: "NO_FETCH_REQUIRED" },
				{ label: "No due date", value: "NO_DUE_DATE_FOUND" },
				{ label: "Billfetch success", value: "BILL_FETCH_SUCCESS" },
				{ label: "Billfetch Failed", value: "BILL_FETCH_FAILED" },
				{ label: "Manual BillPay Enabled", value: "MANUAL_BILLPAY_ENABLED" },
				{ label: "BillPay Pending", value: "BILL_PAY_PENDING" },
				{ label: "BillPay Failed", value: "BILL_PAY_FAILED" },
				{ label: "BillPay Success", value: "BILL_PAY_SUCCESS" },
				{ label: "BillPay Processing", value: "BILL_PAY_PROCESSING" },
				{ label: "Order Created", value: "CREATE_ORDER_SUCCESS" },
				{ label: "Order Failed", value: "CREATE_ORDER_FAILED" }
			],
			activeList: [
				{ value: "Select", label: "Select" },
				{ value: "true", label: "true" },
				{ value: "false", label: "false" },

			],
			consumerList: [],
			consumerStat: 'loading',
			rList: [],
			keys: [],
			activePage: 1,
			startIndex: 0,
			endIndex: 5,
			startDate: '',
			endDate: '',
			status: '',
			active: '',
			searchData: '',
			searchOn: false
		}
	}

	componentDidMount() {
		this.loadConsumerList();
	}
	componentWillUnmount() {
	}



	loadConsumerList = () => {
		var url = '/api/v1/billpay/corp/consumer/get-list/';
		const headers = {
			'Authorization': 'Bearer ' + this.props.token,
			'client-id': this.props.agentInfo,
			'role': this.props.clientRole
		}
		this.setState({
			consumerStat: 'loading',
			searchOn: false
		})

		var totalAmount = 0;
		var totalActives = 0;
		var totalInactives = 0;
		var startDate = "";
		var endDate = "";
		if (this.state.startDate != "") {
			var date1 = new Date(this.state.startDate);

			var year = date1.getFullYear();
			var month = date1.getMonth() + 1;
			var strDate = date1.getDate();
			if (month >= 1 && month <= 9) {
				month = "0" + month;
			}
			if (strDate >= 0 && strDate <= 9) {
				strDate = "0" + strDate;
			}
			startDate = year + '-' + month + '-' + strDate;
		}

		if (this.state.endDate != "") {
			var date2 = new Date(this.state.endDate);

			var year = date2.getFullYear();
			var month = date2.getMonth() + 1;
			var strDate = date2.getDate();
			if (month >= 1 && month <= 9) {
				month = "0" + month;
			}
			if (strDate >= 0 && strDate <= 9) {
				strDate = "0" + strDate;
			}
			endDate = year + '-' + month + '-' + strDate;
		}

		if (startDate != '' && endDate != null) {
			url = url + this.props.agentInfo + '/' + startDate + '/' + endDate;
		} else {
			url = url + this.props.agentInfo + '/all/all';
		}

		httpClient.get(url,
			{ headers }
		).then((response) => {

			this.setState({
				searchOn: false
			})

			var list = [];
			var resList = [];
			var resList1 = [];


			if (this.state.status != "") {
				if (response.data != null &&
					response.data != undefined &&
					response.data != "") {
					response.data.reverse().map(res => {
						if (this.state.status == 'payment_due') {
							if (res.lastBillFetch != undefined &&
								res.lastBillFetch != null &&
								res.dueDate != undefined &&
								res.dueDate != null &&
								res.lastKnownStatus != 'BILL_PAY_SUCCESS') {
								var val1 = moment(res.dueDate).format('YYYY-MM-DD')
								var date1 = new Date(val1);
								var date2 = new Date();
								if (date1 < date2) {
									resList.push(res);
								}
							}
						} else if (this.state.status == 'no_due') {
							if (res.lastBillFetch != undefined &&
								res.lastBillFetch != null &&
								res.lastKnownStatus == 'BILL_PAY_SUCCESS') {
								resList.push(res);
							}
						} else if (this.state.status == 'manual_enabled') {
							if (res.billFetchFailedBeforeBillPay != undefined &&
								res.billFetchFailedBeforeBillPay != null &&
								res.billFetchFailedBeforeBillPay == true) {
									resList.push(res);
							}

						} else {


							if (res.lastKnownStatus == this.state.status) {
								resList.push(res);
							}
						}

					})
				}
			} else {
				resList = response.data;
			}
			//alert("resList..."+JSON.stringify(resList))

			if (this.state.active != "") {
				if (resList.length > 0) {
					resList.map(res => {
						if (this.state.active == "true") {
							if (res.active == true) {
								resList1.push(res);
							}
						}
						if (this.state.active == "false") {
							if (res.active == false) {
								resList1.push(res);
							}
						}
					})
				}
			} else {
				resList1 = resList;
			}
			//alert("resList1..."+JSON.stringify(resList1))

			this.setState({
				consumerList: resList1,
				consumerStat: 'completed',
				activePage: 1,
				startIndex: 0,
				endIndex: 5
			})




			if (response.data != null &&
				response.data != undefined &&
				response.data != "") {
				response.data.reverse().map(res => {


					if (res.optional != null) {
						const map = new Map(Object.entries(res.optional));

						var mapKeys = [...map.keys()];

						var optionMap = {
							key: '',
							value: '',
							id: ''
						}
						mapKeys.map(key => {

							var optionMap = {
								key: key,
								value: map.get(key),
								id: res.id
							}
							list.push(optionMap)
						})



					}


					if (res.active == true) {
						totalActives = totalActives + 1;
					} else {
						totalInactives = totalInactives + 1;
					}
					if (res.currentBillPayAmount != undefined &&
						res.currentBillPayAmount > 0
					) {
						totalAmount = totalAmount + res.lcurrentBillPayAmount;
					}


				})


				this.setState({
					keys: list
				})

				// store.dispatch(totalActiveConsumers(totalActives));
				// store.dispatch(totalInActiveConsumers(totalInactives));

				var rlist = [];
				if (resList1.length > 0) {
					resList1.map(res => {
						var r = res;
						r.optional = JSON.stringify(res.optional);
						rlist.push(r);
					})
				}

				this.setState({
					rList: rlist
				})
			}


		}).catch(error => {
			// store.dispatch(totalConsumerNo(0));
			this.setState({
				consumerStat: 'completed',
				searchOn: true
			})


			if (error.message.includes("401")) {
				tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
			}

		});
	}


	handlePageChangeDefault(pageNumber) {
		this.setState({
			activePage: pageNumber
		})

		console.log(pageNumber);
		var startIndex = (pageNumber - 1) * 5;
		var endIndex = pageNumber * 5;

		this.setState({
			startIndex: startIndex,
			endIndex: endIndex,
		})
	}

	setStartDate = (event) => {
		this.setState({
			startDate: event.target.value
		})
	}

	setEndDate = (event) => {
		this.setState({
			endDate: event.target.value
		})
	}

	statusSelect = (event) => {
		if (event.target.value != '' &&
			event.target.value == 'Select') {
			alert('Please select a value')
			this.setState({
				status: ''
			})

		}
		if (event.target.value != '' &&
			event.target.value != 'Select') {
			if (event.target.value == 'Payment Due') {
				this.setState({
					status: 'payment_due'
				})
			}
		}
		if (event.target.value != '' &&
			event.target.value != 'Select') {
			if (event.target.value == 'No Due/Bill Paid') {
				this.setState({
					status: 'no_due'
				})
			}
		}
		if (event.target.value != '' &&
			event.target.value != 'Select') {
			if (event.target.value == 'MANUAL_BILLPAY_ENABLED') {
				this.setState({
					status: 'manual_enabled'
				})
			}
		}
		if (event.target.value != '' &&
			event.target.value != 'Select') {
			if (event.target.value == 'INITIATED') {
				this.setState({
					status: 'INITIATED'
				})
			}
		}
		if (event.target.value != '' &&
			event.target.value != 'Select') {
			if (event.target.value == 'NO_FETCH_REQUIRED') {
				this.setState({
					status: 'NO_FETCH_REQUIRED'
				})
			}
		}
		if (event.target.value != '' &&
			event.target.value != 'Select') {
			if (event.target.value == 'NO_DUE_DATE_FOUND') {
				this.setState({
					status: 'NO_DUE_DATE_FOUND'
				})
			}
		}
		if (event.target.value != '' &&
			event.target.value != 'Select') {
			if (event.target.value == 'BILL_FETCH_SUCCESS') {
				this.setState({
					status: 'BILL_FETCH_SUCCESS'
				})
			}
		}
		if (event.target.value != '' &&
			event.target.value != 'Select') {
			if (event.target.value == 'BILL_FETCH_FAILED') {
				this.setState({
					status: 'BILL_FETCH_FAILED'
				})
			}
		}
		if (event.target.value != '' &&
			event.target.value != 'Select') {
			if (event.target.value == 'BILL_PAY_PENDING') {
				this.setState({
					status: 'BILL_PAY_PENDING'
				})
			}
		}
		if (event.target.value != '' &&
			event.target.value != 'Select') {
			if (event.target.value == 'BILL_PAY_SUCCESS') {
				this.setState({
					status: 'BILL_PAY_SUCCESS'
				})
			}
		}
		if (event.target.value != '' &&
			event.target.value != 'Select') {
			if (event.target.value == 'BILL_PAY_FAILED') {
				this.setState({
					status: 'BILL_PAY_FAILED'
				})
			}
		}
		if (event.target.value != '' &&
			event.target.value != 'Select') {
			if (event.target.value == 'BILL_PAY_PROCESSING') {
				this.setState({
					status: 'BILL_PAY_PROCESSING'
				})
			}
		}
		if (event.target.value != '' &&
			event.target.value != 'Select') {
			if (event.target.value == 'CREATE_ORDER_SUCCESS') {
				this.setState({
					status: 'CREATE_ORDER_SUCCESS'
				})
			}
		}
		if (event.target.value != '' &&
			event.target.value != 'Select') {
			if (event.target.value == 'CREATE_ORDER_FAILED') {
				this.setState({
					status: 'CREATE_ORDER_FAILED'
				})
			}
		}

	}
	activeSelect = (event) => {
		if (event.target.value != '' &&
			event.target.value == 'Select') {
			alert('Please select a value')
			this.setState({
				active: ''
			})

		}
		if (event.target.value != '' &&
			event.target.value != 'Select') {
			if (event.target.value == 'true') {
				this.setState({
					active: 'true'
				})
			}
		}
		if (event.target.value != '' &&
			event.target.value != 'Select') {
			if (event.target.value == 'false') {
				this.setState({
					active: 'false'
				})
			}
		}

	}

	submit = () => {
		this.loadConsumerList();

	}

	reset = () => {
		this.setState({
			startDate: '',
			endDate: '',
			active: '',
			status: '',
			searchData: '',
			activePage: 1,
			startIndex: 0,
			endIndex: 5,
			searchOn: false
		})
		setTimeout(() => {
			this.loadConsumerList();
		}, 200);
	}

	searchByConsumer = (event) => {
		event.preventDefault();
		this.setState({
			searchData: event.target.value.trim()
		})
	}

	search = (event) => {
		event.preventDefault();
		var consumerList = [];
		this.setState({
			consumerStat: 'loading',
			searchOn: true,
			startIndex: 0,
			endIndex: 1
		})
		var consumerList1 = this.state.consumerList;
		if (consumerList1.length > 0) {
			consumerList1.map(consumer => {
				if (JSON.stringify(consumer).includes(this.state.searchData)) {
					consumerList.push(consumer)
				}
			})
		}

		var rlist = [];
		if (consumerList.length > 0) {
			consumerList.map(res => {
				var r = res;
				r.optional = JSON.stringify(res.optional);
				rlist.push(r);
			})
		}


		setTimeout(() => {
			this.setState({
				consumerList: consumerList,
				consumerStat: 'completed',
				startIndex: 0,
				endIndex: 5,
				rList: rlist

			})
		}, 200);


	}

	render() {

		return (
			<div>
				<div class="main">
					<LeftMenu />

					<div class="right-side">
						<div class="container-fluid">

							<Header />
							<div class="row">
								<div class="col-12">
									<div class="card">
										<div class="dashhead">
											<h3>Consumers List</h3>


											<div class="hisfltr">
												<div class="dropdown filbox">
													<button type="button" class="dropdown-toggle fltrbtn" data-bs-auto-close="outside" id="fltrid" data-bs-toggle="dropdown" aria-expanded="false" aria-haspopup="true"></button>

													<div class="dropdown-menu dropdown-menu-end" aria-labelledby="fltrid">


														<div class="filters">
															<label for="status">Status:</label>
															<select class="form-select" id="status"

																onChange={this.statusSelect} required>

																{this.state.statusList.map(status => (
																	<option value={status.value}
																	>{status.label}</option>
																))}

															</select>
														</div>
														<div class="filters">
															<label for="status">Active:</label>
															<select class="form-select" id="status"

																onChange={this.activeSelect} required>

																{this.state.activeList.map(active => (
																	<option value={active.value}
																	>{active.label}</option>
																))}

															</select>
														</div>

														<div class="filters">
															<label for="select-state">Due Date From:</label>
															<input type="date" name="" placeholder="DD/MM/YYYY"
																value={this.state.startDate}
																onChange={this.setStartDate} />
														</div>
														<div class="filters">
															<label for="select-state">Due Date To:</label>
															<input type="date" name="" placeholder="DD/MM/YYYY"
																value={this.state.endDate}
																onChange={this.setEndDate} />
														</div>
														<div class="filters">
															<button type="button" class="clear" id="btnSubmit" onClick={this.submit}>Submit</button>
															<button type="button" class="clear" id="btnClear" onClick={this.reset}>Clear</button>
														</div>

													</div>
												</div>
											</div>


											<div class="backbtn">
												<Link to='/manage-consumer'>
													<button type="button" class="back" >Back</button>
												</Link>

											</div>
											{this.state.rList.length > 0 &&
												<CSVLink
													class="lbbtn"
													data={this.state.rList}
													asyncOnClick={true}
													// onClick={this.resetExportDate}
													filename={"Consumers_list" + ".csv"}
												>
													Download Consumers
												</CSVLink>
											}


											<div class="headsrch">
												<div class="input-group">
													<input type="text" class="form-control" placeholder="Search Consumer..."
														value={this.state.searchData}
														aria-describedby="srchbtn" onChange={this.searchByConsumer}
														disabled={this.state.searchOn == true ? true : false} />
													<button class="btn" type="button" id="srchbtn" onClick={this.search}
														disabled={this.state.searchOn == true ? true : false}>search</button>
													<button type="button" class="lbbtn" id="btnClear" onClick={this.reset}>Clear</button>
												</div>
											</div>



										</div>


										{/* <ConsumerHistory /> */}
										<div>
											<div class="cnsmrhstry" id="cnsmrlist">

												{this.state.consumerStat != 'loading' &&
													this.state.consumerList.length > 0 &&
													this.state.consumerList.
														slice(this.state.startIndex,
															this.state.endIndex)
														.map(consumer => (
															< ConsumerList consumerVal={consumer}
																consumerOptionalKeys={this.state.keys} />
														))


												}
											</div>

											{this.state.consumerStat == 'loading' &&
												<div>Loading...
													<div class="spinner-grow spinner-grow-sm"></div>
												</div>
											}
											{this.state.consumerStat != 'loading' &&

												this.state.consumerList.length > 0 &&

												<div class="pager">
													<p>Showing {this.state.startIndex + 1} to {this.state.endIndex >=
														this.state.consumerList.length ?
														this.state.consumerList.length :
														this.state.endIndex} of {this.state.consumerList.length} entries</p>
													<Pagination
														activePage={this.state.activePage}
														itemsCountPerPage={5}
														totalItemsCount={
															this.state.consumerList.length}
														pageRangeDisplayed={5}
														onChange={this.handlePageChangeDefault.bind(this)}
														className="pagination"
														linkClass="page-link"
														itemClass="page-item"
													/>
												</div>
												// :
												// this.state.consumerList.length > 0 &&
												// <div class="pager">
												// 	<p>Showing {this.state.startIndex + 1} to {
												// 		this.state.endIndex} of {this.state.consumerList.length} entries</p>
												// </div>

											}
											{this.state.consumerStat != 'loading' &&
												this.state.consumerList.length == 0 &&
												<div class='valid-success'>No Consumer Found.</div>}
										</div>

									</div>
								</div>
							</div>
						</div>



					</div>

				</div>
				<div class="footer-txt">Copyright &copy; 2021 All rights reserved. <br />Powered by FinXpay Solutions Pvt. Ltd.</div>
			</div>


		);
	}
}

const mapStateToProps = (
	{ errorMessageReduce: { errorMessage },
		miscReduce: { phone, agentInfo, clientRole, token } }
) => ({
	errorMessage, phone, agentInfo, clientRole, token
});

export default connect(mapStateToProps, null)(AllConsumer);
